import moment from 'moment';
import _ from 'lodash'

const mapPropsToValues = props => {
  const { user = {} } = props;

  if (props.validateGeneratePdfForm) {
    return {
      termsAndConditions1: false,
      termsAndConditions2: false,
      termsAndConditions3: false,
      signedIn: '',
    };
  }

  if (props.validateSignDocumentForm) {
    return {
      signDate: moment().format('YYYY-MM-DD'),
      signPlace: '',
    };
  }

  return _.mapValues(user, value => value || '')
};

export default mapPropsToValues;



// WEBPACK FOOTER //
// ./src/components/LoaLawyer/Form/mapPropsToValues.js